module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Death-Of-Stalin-The.d3329c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Death-Of-Stalin-The.jpg
// module id = S8W0
// module chunks = 0